import { render, staticRenderFns } from "./StateNew.vue?vue&type=template&id=08ece144&scoped=true&lang=html&"
import script from "./StateNew.vue?vue&type=script&lang=coffee&"
export * from "./StateNew.vue?vue&type=script&lang=coffee&"
import style0 from "./StateNew.vue?vue&type=style&index=0&id=08ece144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ece144",
  null
  
)

component.options.__file = "StateNew.vue"
export default component.exports